export enum QuotationPdfFormat {
  NORMAL = "normal",
  BOQ = "boq",
}

export enum QuotationStatus {
  DRAFT = "DRAFT", // being prepared internally
  ACCEPTED = "ACCEPTED", // customer approved
  REJECTED = "REJECTED", // customer declined
  EXPIRED = "EXPIRED", // validity date passed
  CANCELLED = "CANCELLED", // manually withdrawn
}

export enum QuotationSourceType {
  ENQUIRY = "ENQUIRY",
  AMC = "AMC",
}

export enum QuotationType {
  AMC = "AMC",
  AMC_VISIT = "AMC_VISIT",
  SERVICE = "SERVICE",
  PETTY_WORK = "PETTY_WORK",
}

export enum QuotationItemType {
  MATERIAL = "MATERIAL",
  LABOR = "LABOR",
  SERVICE = "SERVICE",
}

export const QuotationItemTypeLabelMap: Record<QuotationItemType, string> = {
  [QuotationItemType.MATERIAL]: "Material",
  [QuotationItemType.LABOR]: "Labour",
  [QuotationItemType.SERVICE]: "Service",
};

export const QuotationTypeLabelMap: Record<QuotationType, string> = {
  [QuotationType.AMC]: "Annual Maintenance Contract",
  [QuotationType.AMC_VISIT]: "AMC Visit",
  [QuotationType.SERVICE]: "Service",
  [QuotationType.PETTY_WORK]: "Petty Work",
};

export const QuotationSourceLabelMap: Record<QuotationSourceType, string> = {
  [QuotationSourceType.ENQUIRY]: "Enquiry",
  [QuotationSourceType.AMC]: "Annual Maintenance Contract",
};

/** Backend: only these may move to CANCELLED. */
export const QUOTATION_STATUSES_CANCELLABLE: QuotationStatus[] = [
  QuotationStatus.DRAFT,
];

export function quotationWorkflowFlags(status: string) {
  const s = status as QuotationStatus;
  return {
    canSend: s === QuotationStatus.DRAFT,
    canResend: s === QuotationStatus.ACCEPTED,
    canAccept: s === QuotationStatus.DRAFT,
    canReject: s === QuotationStatus.DRAFT,
    canCancel: QUOTATION_STATUSES_CANCELLABLE.includes(s),
    canEdit: s === QuotationStatus.DRAFT,
    canDelete: s === QuotationStatus.DRAFT,
  };
}

export const QuotationStatusMap: Record<
  QuotationStatus,
  { label: string; color: string; hint: string | undefined }
> = {
  [QuotationStatus.DRAFT]: {
    label: "Draft",
    color: "primary",
    hint: "Quotation is being prepared internally.",
  },
  [QuotationStatus.ACCEPTED]: {
    label: "Accepted",
    color: "secondary",
    hint: "Customer has approved the quotation.",
  },
  [QuotationStatus.REJECTED]: {
    label: "Rejected",
    color: "danger",
    hint: "Customer has rejected the quotation.",
  },
  [QuotationStatus.EXPIRED]: {
    label: "Expired",
    color: "danger",
    hint: "Quotation has expired due to its validity date.",
  },
  [QuotationStatus.CANCELLED]: {
    label: "Cancelled",
    color: "danger",
    hint: "Quotation has been cancelled.",
  },
};
